// extracted by mini-css-extract-plugin
module.exports = {"attendeesContent":"AttendeesContainer_attendeesContent__16NWg"};